import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/feature/Header";
import WelcomeScreen from "./welcomeScreen";
import InterviewScreen from "./interviewScreen";
import CompletedScreen from "./completedScreen";

export default function AIInterview() {
  const [hasStarted, setHasStarted] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const navigate = useNavigate();

  const handleStartInterview = () => {
    console.log("🚀 Starting interview...");
    setHasStarted(true);
  };

  const handleFinishInterview = () => {
    console.log("✅ Interview ended, returning home...");
    setIsCompleted(false);
    setHasStarted(false);
    navigate("/home");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100">
      <Header showAuth={false} />

      {!hasStarted && !isCompleted && (
        <WelcomeScreen onStart={handleStartInterview} />
      )}

      {hasStarted && !isCompleted && (
        <InterviewScreen onComplete={() => setIsCompleted(true)} />
      )}

      {isCompleted && (
        <CompletedScreen onFinish={handleFinishInterview} />
      )}
    </div>
  );
}
